import { useTranslation } from 'react-i18next'

import AppBar from '@mui/material/AppBar'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import ArrowRightAltRoundedIcon from '@mui/icons-material/ArrowRightAltRounded'

export type BottomBarProps = {
  disabled?: boolean
  isFirst?: boolean
  isLast?: boolean
  onComplete?: () => void
  onNext?: () => void
  onPrevious?: () => void
}

export function BottomBar(props: BottomBarProps) {
  const { disabled = false, isFirst = false, isLast = false, onComplete, onNext, onPrevious } = props
  const { t } = useTranslation()
  return (
    <AppBar position="fixed" color="transparent" sx={{ top: 'auto', bottom: 0 }}>
      <ButtonGroup disableElevation variant="contained" sx={{ flex: 1 }}>
        {!isFirst && (
          <Button
            color="secondary"
            onClick={onPrevious}
            startIcon={<ArrowRightAltRoundedIcon sx={{ transform: 'rotate(180deg)' }} />}
            sx={{ borderRadius: 0, flex: 1, height: '50px' }}
          >
            {t('common:button.previous.label')}
          </Button>
        )}
        {!isLast ? (
          <Button disabled={disabled} onClick={onNext} endIcon={<ArrowRightAltRoundedIcon />} sx={{ borderRadius: 0, flex: 1, height: '50px' }}>
            {t('common:button.next.label')}
          </Button>
        ) : (
          <Button disabled={disabled} onClick={onComplete} sx={{ borderRadius: 0, flex: 1, height: '50px' }}>
            {t('common:button.complete.label')}
          </Button>
        )}
      </ButtonGroup>
    </AppBar>
  )
}

export default BottomBar
